import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { map } from 'rxjs/operators';
import { IJsonApiResponse } from '../json-api/json-api.interface';

/**
 * Service for Amazon Web Service related functionality
 */
@Injectable()
export class AwsService {
    constructor(private http: HttpServiceHelper) {
    }

    public getS3UploadHash(folderName: string): Observable<any> {
        // Make the http request
        let apiUrl: string = `${this.http.configService.getApiBaseUrl()}/aws/s3-upload-hash`;

        const queryParams: string[] =
            [
                `folderName=${folderName}`,
            ];
        apiUrl += this.http.getQueryParameters(null, queryParams);

        return this.http.get(apiUrl)
            .pipe(map((response: IJsonApiResponse) => response));
    }
}
